module.exports = {"440784001":"沙坪街道","440784101":"龙口镇","440784102":"雅瑶镇","440784103":"古劳镇","440784104":"桃源镇","440784105":"鹤城镇","440784106":"共和镇","440784107":"址山镇","440784108":"宅梧镇","440784112":"双合镇","440784401":"广东省江门监狱","440784402":"江门市四堡林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440784.json
// module id = 2121
// module chunks = 0